import { Action } from '@ngrx/store';
import { Notification } from '../../../models/notification.model';
import { Interval } from '@model';

export enum NotificationActionTypes {
  NotificationLoadData = '[Notification] Load data',
  NotificationLoadDataSuccess = '[Notification] Load success',
  NotificationLoadDataFail = '[Notification] Load fail',

  NotificationLoadUnreadCount = '[Notification] Load unread count',
  NotificationLoadUnreadCountSuccess = '[Notification] Load unread count success',
  NotificationLoadUnreadCountFail = '[Notification] Load unread count fail',

  NotificationLoadCount = '[Notification] Load count',
  NotificationLoadCountSuccess = '[Notification] Load count success',
  NotificationLoadCountFail = '[Notification] Load count fail',

  NotificationSetAsRead = '[Notification] Set as read',
  NotificationSetAsReadSuccess = '[Notification] Set as read success',
  NotificationSetAsReadFail = '[Notification] Set as read fail',

  NotificationIntervalSetAsRead = '[Notification] Set interval as read',
  NotificationIntervalSetAsReadSuccess = '[Notification] Set interval as read success',
  NotificationIntervalSetAsReadFail = '[Notification] Set interval as read fail',

  NotificationIntervalLoadData = '[Notification] Load interval data',
  NotificationIntervalLoadDataSuccess = '[Notification] Load interval success',
  NotificationIntervalLoadDataFail = '[Notification] Load interval fail',

  NotificationRemove = '[Notification] remove',
  NotificationRemoveSuccess = '[Notification] remove success',
  NotificationRemoveFail = '[Notification] remove fail',

  NotificationBulkRemove = '[Notification] bulk remove',
  NotificationBulkRemoveSuccess = '[Notification] bulk remove success',
  NotificationBulkRemoveFail = '[Notifications] bulk remove fail' 
}

export class NotificationLoad implements Action {
  readonly type = NotificationActionTypes.NotificationLoadData;
  constructor() {}
}
export class NotificationLoadSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationLoadDataSuccess;
  constructor(public payload: Notification[]) {}
}
export class NotificationLoadFail implements Action {
  readonly type = NotificationActionTypes.NotificationLoadDataFail;
  constructor(public payload: any) {}
}

export class NotificationRemove implements Action {
  readonly type = NotificationActionTypes.NotificationRemove;
  constructor(public payload: Notification) {}
}
export class NotificationRemoveSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationRemoveSuccess;
  constructor(public payload: Notification) {}
}
export class NotificationRemoveFail implements Action {
  readonly type = NotificationActionTypes.NotificationRemoveFail;
  constructor(public payload: any) {}
}

export class NotificationBulkRemove implements Action {
  readonly type = NotificationActionTypes.NotificationBulkRemove;
  constructor(public payload: number[]) {}
}
export class NotificationBulkRemoveSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationBulkRemoveSuccess;
  constructor(public payload: number[]) {}
}
export class NotificationBulkRemoveFail implements Action {
  readonly type = NotificationActionTypes.NotificationBulkRemoveFail;
  constructor(public payload: any) {}
}

export class NotificationLoadUnreadCount implements Action {
  readonly type = NotificationActionTypes.NotificationLoadUnreadCount;
  constructor() {}
}

export class NotificationLoadUnreadCountSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationLoadUnreadCountSuccess;
  constructor(public payload: number) {}
}

export class NotificationLoadUnreadCountFail implements Action {
  readonly type = NotificationActionTypes.NotificationLoadUnreadCountFail;
  constructor(public payload: any) {}
}

export class NotificationLoadCount implements Action {
  readonly type = NotificationActionTypes.NotificationLoadCount;
  constructor() {}
}

export class NotificationLoadCountSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationLoadCountSuccess;
  constructor(public payload: number) {}
}

export class NotificationLoadCountFail implements Action {
  readonly type = NotificationActionTypes.NotificationLoadCountFail;
  constructor(public payload: any) {}
}

export class NotificationSetAsRead implements Action {
  readonly type = NotificationActionTypes.NotificationSetAsRead;
  constructor(public payload: Notification) {}
}

export class NotificationSetAsReadSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationSetAsReadSuccess;
  constructor(public payload: Notification) {}
}

export class NotificationSetAsReadFail implements Action {
  readonly type = NotificationActionTypes.NotificationSetAsReadFail;
  constructor(public payload: any) {}
}

export class NotificationIntervalSetAsRead implements Action {
  readonly type = NotificationActionTypes.NotificationIntervalSetAsRead;
  constructor(public payload: Interval) {}
}

export class NotificationIntervalSetAsReadSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationIntervalSetAsReadSuccess;
  constructor(public payload: Notification[]) {}
}

export class NotificationIntervalSetAsReadFail implements Action {
  readonly type = NotificationActionTypes.NotificationIntervalSetAsReadFail;
  constructor(public payload: any) {}
}

export class NotificationLoadInterval implements Action {
  readonly type = NotificationActionTypes.NotificationIntervalLoadData;
  constructor(public payload: Interval) {}
}

export class NotificationLoadIntervalSuccess implements Action {
  readonly type = NotificationActionTypes.NotificationIntervalLoadDataSuccess;
  constructor(public payload: Notification[]) {}
}

export class NotificationLoadIntervalFail implements Action {
  readonly type = NotificationActionTypes.NotificationIntervalLoadDataFail;
  constructor(public payload: any) {}
}

export type NotificationActions =
  | NotificationLoad
  | NotificationLoadSuccess
  | NotificationLoadFail
  | NotificationLoadUnreadCount
  | NotificationLoadUnreadCountSuccess
  | NotificationLoadUnreadCountFail
  | NotificationLoadCount
  | NotificationLoadCountSuccess
  | NotificationLoadCountFail
  | NotificationSetAsRead
  | NotificationSetAsReadSuccess
  | NotificationSetAsReadFail
  | NotificationIntervalSetAsRead
  | NotificationIntervalSetAsReadSuccess
  | NotificationIntervalSetAsReadFail
  | NotificationLoadInterval
  | NotificationLoadIntervalSuccess
  | NotificationLoadIntervalFail
  | NotificationRemove
  | NotificationRemoveSuccess
  | NotificationRemoveFail
  | NotificationBulkRemove
  | NotificationBulkRemoveSuccess
  | NotificationBulkRemoveFail;
